import { render, staticRenderFns } from "./OrdensServicos.vue?vue&type=template&id=a7eb6c9e&"
import script from "./OrdensServicos.vue?vue&type=script&lang=js&"
export * from "./OrdensServicos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports